import { render, staticRenderFns } from "./CharacterMainGear.vue?vue&type=template&id=1a739dfb&"
import script from "./CharacterMainGear.vue?vue&type=script&lang=js&"
export * from "./CharacterMainGear.vue?vue&type=script&lang=js&"
import style0 from "./CharacterMainGear.vue?vue&type=style&index=0&id=1a739dfb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports